module.exports = __webpack_public_path__ + "img/role-title-ja.37606f8b.png";